// This file was automatically generated from core.html.
// Please don't edit this file by hand.

goog.provide('el8.template.core');

goog.require('soy');
goog.require('soy.StringBuilder');


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.core.listItem = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<li class="', (opt_data.noBullet) ? 'el8NoBullet' : 'el8BulletText', '">', (opt_data.textReplaced) ? '<span class="el8Strike">' + soy.$$escapeHtml(opt_data.textReplaced) + '</span> ' : '', '<span class="el8ListBreak el8Preserve', (opt_data.isReplaced) ? ' el8Strike' : (opt_data.isEdit) ? ' el8Edit' : '', (opt_data.triggerClass) ? ' ' + soy.$$escapeHtml(opt_data.triggerClass) : '', '"', (opt_data.itemId) ? ' data-id="' + soy.$$escapeHtml(opt_data.itemId) + '"' : '', '>', (opt_data.noHighlight) ? (opt_data.text) ? soy.$$escapeHtml(opt_data.text) : (opt_data.safeText) ? opt_data.safeText : '' : (opt_data.text) ? (el8.appservice && el8.appservice.highlighter ? el8.appservice.highlighter.highlightText(soy.$$escapeHtml(opt_data.text)) : soy.$$escapeHtml(opt_data.text)) : (opt_data.safeText) ? (el8.appservice && el8.appservice.highlighter ? el8.appservice.highlighter.highlightText(opt_data.safeText) : opt_data.safeText) : '', '</span> ', (opt_data.signUserFullName) ? '<span class="el8SystemText">-- ' + ((opt_data.noHighlight) ? soy.$$escapeHtml(opt_data.signUserFullName) : (el8.appservice && el8.appservice.highlighter ? el8.appservice.highlighter.highlightText(soy.$$escapeHtml(opt_data.signUserFullName)) : soy.$$escapeHtml(opt_data.signUserFullName))) + '</span>' : '', '</li>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.core.textItem = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<p>', (opt_data.textReplaced) ? '<span class="el8Strike">' + soy.$$escapeHtml(opt_data.textReplaced) + '</span> ' : '', '<span class="el8Preserve', (opt_data.isReplaced) ? ' el8Strike' : (opt_data.isEdit) ? ' el8Edit' : '', (opt_data.triggerClass) ? ' ' + soy.$$escapeHtml(opt_data.triggerClass) : '', '"', (opt_data.itemId) ? ' data-id="' + soy.$$escapeHtml(opt_data.itemId) + '"' : '', '>', (opt_data.noHighlight) ? (opt_data.text) ? soy.$$escapeHtml(opt_data.text) : (opt_data.safeText) ? opt_data.safeText : '' : (opt_data.text) ? (el8.appservice && el8.appservice.highlighter ? el8.appservice.highlighter.highlightText(soy.$$escapeHtml(opt_data.text)) : soy.$$escapeHtml(opt_data.text)) : (opt_data.safeText) ? (el8.appservice && el8.appservice.highlighter ? el8.appservice.highlighter.highlightText(opt_data.safeText) : opt_data.safeText) : '', '</span> ', (opt_data.signUserFullName) ? '<span class="el8SystemText">-- ' + ((opt_data.noHighlight) ? soy.$$escapeHtml(opt_data.signUserFullName) : (el8.appservice && el8.appservice.highlighter ? el8.appservice.highlighter.highlightText(soy.$$escapeHtml(opt_data.signUserFullName)) : soy.$$escapeHtml(opt_data.signUserFullName))) + '</span>' : '', '</p>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.core.collapseIcon = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<span class="el8DownArrowIcon"></span>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.core.expandIcon = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<span class="el8LeftArrowIcon"></span>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.core.unknownPatient = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="notify-unknown-patient el8FieldSection" style="display:none;"><div class="el8NotificationCaution el8FieldMediumLabelPadding"><p class="lgFont">Patient not found. <a class="new-patient-trigger">Create a new chart.</a></p></div></div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.core.actionsButton = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<button type="button" class="el8ActionButton">Actions<span class="el8ButtonDropdownIcon"></span></button>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.core.newTag = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<span class="el8NewChartItem">New</span>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.core.singleField = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  var bList125 = opt_data.bullets;
  var bListLen125 = bList125.length;
  for (var bIndex125 = 0; bIndex125 < bListLen125; bIndex125++) {
    var bData125 = bList125[bIndex125];
    output.append(soy.$$escapeHtml(bData125.text), (! (bIndex125 == bListLen125 - 1)) ? '; ' : '');
  }
  if (!opt_sb) return output.toString();
};
